import { Cash } from '@shared/icons';
import { useTranslations } from 'next-intl';

type EmptyTransactionsListProps = {
  namespace: string;
};

function EmptyTransactionsList({ namespace }: EmptyTransactionsListProps) {
  const t = useTranslations(namespace);
  return (
    <div data-testid="empty-transactions-list" className="flex flex-col gap-4 py-10 px-4 items-center justify-center">
      <Cash className="h-16 w-16" />
      <div className="text-center">
        <p className="text-foreground-subtle">{t('empty_transactions_list_title')}</p>
        <p className="text-foreground-subtle">{t('empty_transactions_list_message')}</p>
      </div>
    </div>
  );
}

export { EmptyTransactionsList };
